/**
 * SDX React Component Mounter - entry point.
 *
 * This file is intentionally short. The framework-agnostic
 * mount pipeline lives in `@sdx/core/mount`; this entry script
 * only constructs the React adapter, hands it to the core
 * bootstrap, and registers a navigation-engine resolver so SPA
 * preloads can find React component bundles.
 *
 * The same pattern repeats verbatim in sdx_vue/mount.ts and
 * sdx_svelte/mount.ts. Adding a new SDX framework module means
 * writing one adapter file and a five-line entry script.
 */

import { bootstrapFrameworkMount } from '@sdx/core/mount';
import { registerNavigationComponentResolver } from '@sdx/core/contracts';
import { reactMountAdapter } from './mount/adapter';
import { resolveComponentUrlForNavigation } from './mount/component-resolver';

bootstrapFrameworkMount(reactMountAdapter);

registerNavigationComponentResolver(resolveComponentUrlForNavigation);
